<work-view [doneTasks]="workContextService.doneTasks$|async"
           [isShowBacklog]="false"
           [undoneTasks]="workContextService.undoneTasks$|async"></work-view>
